import { formatDecimal } from 'framework/utils';

export const clampPercent = (value: number) => Math.max(0, Math.min(100, value));

export const formatHours = (hours: number) => `${formatDecimal(hours)}h`;

export const formatScaleHours = (hours: number) => formatDecimal(hours);

export const formatHourRange = (minHours: number, maxHours: number) =>
  `${formatHours(minHours)} - ${formatHours(maxHours)}`;

const MAX_OVERFLOW_WIDTH_PERCENT = 40;

export const getOverflowWidthPercent = (progressPercent: number) =>
  Math.min(MAX_OVERFLOW_WIDTH_PERCENT, Math.max(0, progressPercent - 100));
